<app-loading [sticky]="stickyLoading" *ngIf="displayLoadingIndicator && (service.loading$ | async) else notLoading" [showText]="!!loadingMessage" [text]="loadingMessage"></app-loading>
<ng-template #notLoading>
    <app-error-text *ngIf="service.error$ | async as err else loaded" [error]="err"></app-error-text>
</ng-template>
<ng-template #loaded>
    <ng-content></ng-content>
</ng-template>
